import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../assets/Images/logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuLinks = [
    { name: "About", id: "about" },
    { name: "How It Works", id: "how-it-works" },
    { name: "Features", id: "features" },
    { name: "Pricing", id: "portal" },
    { name: "Cancellation", id: "cancellation" },
    { name: "Contact", id: "contact" }
  ];

  const handleScroll = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = 85; 
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    setIsMenuOpen(false); 
  };

  return (
    <nav className="doctor-nav">
      <div className="nav-wrapper">
        
        {/* Logo with Fade-in-Left Animation */}
        <div className="logo-area fade-in-left">
          <img src={logo} alt="TheDoctorAtHome" className="nav-logo-img" />
        </div>

        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            {menuLinks.map((link, index) => (
              <li 
                key={index} 
                className="fade-in-left" // Same as Logo animation
                style={{ animationDelay: `${0.3 + index * 0.1}s` }} // Logo ke baad start hoga
              >
                <a 
                  href={`#${link.id}`} 
                  className="nav-item"
                  onClick={(e) => handleScroll(e, link.id)}
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mobile-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <div className={isMenuOpen ? "line open" : "line"}></div>
          <div className={isMenuOpen ? "line open" : "line"}></div>
          <div className={isMenuOpen ? "line open" : "line"}></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;